import * as React from "react";

import ManageUsers from "../ManageUsers";

const UsersPanel: React.FC = () => {
	return <ManageUsers />;
};

export default UsersPanel;
